var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.820312,
    y: 0.0439453,
    width: 41.183,
    height: 40.5065,
    rx: 20.2532,
    fill: "#12B897"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4191 25.7556C25.7205 25.7556 25.9548 25.8393 26.1223 26.0067C26.2964 26.1741 26.3834 26.3951 26.3834 26.6696V28.2969H16.2785V27.3929C16.2785 27.2188 16.3154 27.0313 16.389 26.8304C16.4627 26.6228 16.5866 26.4353 16.7607 26.2679L21.0799 21.9386C21.4482 21.5703 21.7729 21.2188 22.0542 20.8839C22.3354 20.5424 22.5698 20.211 22.7573 19.8895C22.9448 19.5614 23.0854 19.2299 23.1792 18.8951C23.2729 18.5603 23.3198 18.2087 23.3198 17.8404C23.3198 17.1909 23.1524 16.6987 22.8176 16.3639C22.4828 16.0223 22.0107 15.8516 21.4013 15.8516C21.1334 15.8516 20.8857 15.8918 20.658 15.9721C20.437 16.0458 20.2361 16.1496 20.0553 16.2835C19.8812 16.4174 19.7305 16.5748 19.6033 16.7556C19.4761 16.9364 19.3823 17.134 19.322 17.3482C19.2015 17.6831 19.0374 17.9074 18.8299 18.0212C18.629 18.1284 18.341 18.1518 17.966 18.0915L16.4995 17.8304C16.6066 17.1206 16.8075 16.4978 17.1022 15.9621C17.3968 15.4264 17.7651 14.9811 18.2071 14.6261C18.6491 14.2712 19.1546 14.0067 19.7238 13.8326C20.293 13.6518 20.9057 13.5614 21.562 13.5614C22.2517 13.5614 22.8778 13.6652 23.4403 13.8728C24.0095 14.0737 24.495 14.3583 24.8968 14.7266C25.2986 15.0882 25.61 15.5268 25.831 16.0424C26.0519 16.5581 26.1624 17.1273 26.1624 17.75C26.1624 18.2857 26.0854 18.7813 25.9314 19.2366C25.7774 19.692 25.5665 20.1272 25.2986 20.5424C25.0374 20.9509 24.7327 21.3493 24.3845 21.7377C24.0363 22.1261 23.668 22.5179 23.2796 22.913L20.1859 26.077C20.5274 25.9766 20.8656 25.8996 21.2004 25.846C21.5352 25.7857 21.8499 25.7556 22.1446 25.7556H25.4191Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep02);
export default __webpack_public_path__ + "static/media/step-02.c270b09731aa2abbc30c5b9c50b3324a.svg";
export { ForwardRef as ReactComponent };